import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { CenterContentComponent } from './center-content.component';

@NgModule({
  imports: [ CommonModule, FormsModule, IonicModule,],
  declarations: [CenterContentComponent],
  exports: [CenterContentComponent]
})
export class CenterContentComponentModule {}
